import setCurrentPage from "src/Utils/setCurrentPage";
import ConversationEffect from "src/Animations/ConversationEffect";

export const DATA_NOT_DEMO_TCA_3 = {
  title: "Seamlessly configure network services \nto align to changing needs",
  subtitle: "Network operation team",
  text: "Empower your network: design and execute configuration\n templates across network functions via CLI, Netconf, and Rest\n API Channels. \n\nExperience versioning, history tracking, and scheduling for\n unparalleled control.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_315"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => {
      setCurrentPage("ILO_313");
    },
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Demo_bg.jpg",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ILO/TCA/TCA_NOT_Demo_3_1.png",
          imageStyle: { position: "absolute", top: "0", right: "0" },
        },
        {
          image: "ILO/TCA/TCA_NOT_Demo_3_2.png",
          imageStyle: { position: "absolute", top: "0", right: "0" },
        },
      ]}
      conversationStyle={{ width: "auto" }}
      pageNumber={"ILO_314"}
    />
  ),
};
